import AppUtils from "@src/utils/appUtils";
import * as mockedAuthEnpointsImport from "../mocks/serviceProxies/authorizationProxy";
import * as mockedOperatorEndpointsImport from "../mocks/serviceProxies/operatorProxy";
import * as mockedManagerEndpointsImport from "../mocks/serviceProxies/managerProxy";
import * as mockedAdminEndpointsImport from "../mocks/serviceProxies/adminProxy";

import * as mockedSharedEndpointsImport from "../mocks/serviceProxies/sharedEndpointsProxy";
import * as authEndpointsImport from "./authService";
import * as operatorEndpointsImport from "./operatorService";
import * as managerEndpointsImport from "./managerService";
import * as adminEndpointsImport from "./adminService";
import * as sharedEndpointsImport from "./sharedServices";

let authEndpoints = {};
let operatorEndpoints = {};
let managerEndpoints = {};
let adminEndpoints = {};
let sharedEndpoints = {};

if (AppUtils.isMockedApp) {
  console.log("load mock endpoints");
  authEndpoints = mockedAuthEnpointsImport;
  operatorEndpoints = mockedOperatorEndpointsImport;
  managerEndpoints = mockedManagerEndpointsImport;
  adminEndpoints = mockedAdminEndpointsImport;
  sharedEndpoints = mockedSharedEndpointsImport;
} else {
  console.log("load real endpoints");
  authEndpoints = authEndpointsImport;
  operatorEndpoints = operatorEndpointsImport;
  managerEndpoints = managerEndpointsImport;
  adminEndpoints = adminEndpointsImport;
  sharedEndpoints = sharedEndpointsImport;
}

export {
  authEndpoints,
  operatorEndpoints,
  managerEndpoints,
  adminEndpoints,
  sharedEndpoints,
};
